var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2 6.8C13.2 6.35817 13.5582 6 14 6C14.4418 6 14.8 6.35817 14.8 6.8V13.2H21.2C21.6418 13.2 22 13.5582 22 14C22 14.4419 21.6418 14.8 21.2 14.8H14.8V21.2C14.8 21.6418 14.4418 22 14 22C13.5582 22 13.2 21.6418 13.2 21.2V14.8H6.8C6.35817 14.8 6 14.4419 6 14C6 13.5582 6.35817 13.2 6.8 13.2H13.2V6.8Z",
    fill: "#D0D0D0"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 26,
    height: 26,
    rx: 13,
    stroke: "#D0D0D0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeDasharray: "2 4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadGrey);
export default __webpack_public_path__ + "static/media/upload-grey.105e7de0cb723aab32bd5748f26e44ad.svg";
export { ForwardRef as ReactComponent };